<script lang="ts">
	import VideoItem from './components/VideoItem.vue';
	import { defineComponent } from 'vue';
    import VideoHiL from './components/VideoHiL.vue';
    import NavbarTs from "@/pages/components/Generales/NavbarInd.vue";
	import Botones from './components/Botones.vue';
	import CarruVideosEscol from './components/CarruVideosEscol.vue';
	import HoverNivel from './components/oferta/OfertaTresImagenes.vue';
    import OfertaBotones from './components/landing/OfertaBotones.vue';
    import GraficoMapa from './components/landing/GraficoMapa.vue';
    import { colegiaturaLicEjec } from '@/main';
    import Presentacion from './components/landing/Presentacion.vue';
    import '@fortawesome/fontawesome-free/css/all.min.css';


	export default defineComponent({
		components: { VideoItem, VideoHiL, Botones, CarruVideosEscol, HoverNivel, NavbarTs, OfertaBotones, GraficoMapa, Presentacion },
		data() {
			return {
				colegiaturaLicEjec: colegiaturaLicEjec,
                showVideoIndex: 0,
                isAnimating: false,
				showVideoX: true,
				backgroundImage: "/pagesImages/alt-virtual.jpg",
				img2: "./pagesImages/ejecutivo-video.jpg",
				buttons: {
					button1: { imageUrl: "/pagesImages/explorar_off.png", hoverImageUrl: "/pagesImages/explorar_on.png" },
					button2: { imageUrl: "/pagesImages/conocelos_off.png", hoverImageUrl: "/pagesImages/conocelos_on.png" },
					button3: { imageUrl: "/pagesImages/leer_off.png", hoverImageUrl: "/pagesImages/leer_on.png" },
					button4: { imageUrl: "/pagesImages/inscribete_white.png", hoverImageUrl: "/pagesImages/inscribete_on.png" },
					button5: { imageUrl: "/pagesImages/visitanos_off.png", hoverImageUrl: "/pagesImages/visitanos_on.png" },
				},
				videoUrl: "https://www.youtube.com/embed/FgQI0J73P7g?si=zqrzcK-aDPUko3IT",
				videoUrl2: "https://www.youtube.com/embed/bA3DNFmpeIs?si=J3d97hR3yZQHlF9y",
				img: "./pagesImages/modalidad-virtual-portada.webp",
				items: [
					{
						image: "/pagesImages/muestra-1.jpg",
						video: "https://www.youtube.com/embed/RlBSrAyGa4o?si=V5KyeMTMtRMl8Miw",
					},
					{
						image: "/pagesImages/muestra-2.jpg",
						video: "https://www.youtube.com/embed/hIV691ryl90?si=zKuJJVpH74aQutHz",
					},
					{
						image: "/pagesImages/muestra-3.jpg",
						video: "https://www.youtube.com/embed/LkAyGgORQJo?si=ByCGvAHS5kdONKw5",
					},
					{
						image: "/pagesImages/muestra-4.jpg",
						video: "https://www.youtube.com/embed/6H8nKbdNVh8?si=ZPqaXU6Bxk9lsOYA",
					},
				],
				imageLinks: [
					{
						imageUrl: '/pagesImages/lic-virtual.jpg',
						links: [
							{ to: '/licenciatura-en-derecho', text: 'Derecho' },
							{ to: '/licenciatura-en-administracion', text: 'Administraci&oacute;n' },
							{ to: '/licenciatura-en-contabilidad', text: 'Contabilidad' },
							{ to: '/licenciatura-en-educacion', text: 'Educaci&oacute;n' },
							{ to: '/licenciatura-en-psicologia', text: 'Psicolog&iacute;a' },
						],
					},
					{
						imageUrl: '/pagesImages/maes-virtual.jpg',
						links: [
							{ to: '/maestria-en-derecho-corporativo', text: 'Derecho Corporativo' },
							{ to: '/maestria-en-alta-direccion', text: 'Alta Direcci&oacute;n' },
							{ to: '/maestria-en-psicoterapia', text: 'Psicoterapia' },
							{ to: '/maestria-en-educacion', text: 'Educaci&oacute;n' },
						],
					},
				],
			};
		},
		methods: {
			showVideo(index: number): void {
				this.showVideoIndex = index;
			},
			showVideo2(): void {
				this.showVideoX = false;
			},
        },
        mounted() {
            setTimeout(() => {
                this.isAnimating = true; // Actualiza la propiedad después del delay
            }, 50);
        },
	});
</script>

<template>
    <section class="flex pt-[88px] lg:pt-[143px] justify-center items-center mb-12 w-full flex-col">
        <div class="flex items-center justify-center w-full bg-center bg-cover md:bg-[center-right] bg-no-repeat" style="background-image: url(/pagesImages/ecabezado-modelo-virtual.webp)">
            <div class="flex justify-center w-full bg-white/20">
                <div class="flex text-justify w-full justify-center items-center max-w-4xl  lg:max-w-[1200px]">
                    <div :class="['w-full box items-end flex md:mb-56  my-8 md:my-0 md:mt-32 flex-col px-4', { 'visible': isAnimating }]">
                        <h1>
                            <span class="block font-normal text-right mb-0 text-[30px] text-[#73793B]">Modelo</span>
                            <span class="sr-only whitespace-nowrap">&nbsp;</span>
                            <span class="block font-serif text-[#73793B] text-[50px] mb-2">Virtual</span>
                        </h1>
                        <p class="text-gray-800 font-serif text-right mb-4 text-[19px]">
                            “Un aprendizaje de excelencia disponible desde cualquier lugar.”
                        </p>
                        <router-link to="/campus/virtual" class="flex justify-end items-end w-[140px] h-[38px]">
                            <div class="flex items-center justify-center w-[140px] h-[38px] py-2 bg-[#73793B] hover:bg-[#F1F2F3] hover:text-black text-white text-lg transition duration-300 ease-in-out">
                                <span>Conoce más</span>
                            </div>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </section>

	<section class="flex flex-col items-center w-full justify-center">
        <div class="flex w-full items-center justify-center">
            <div class="flex flex-col items-center w-full max-w-4xl lg:max-w-[1200px] px-4">
                <p class="font-serif md:text-[36px] text-3xl leading-tight text-[#73793B] mb-2 w-full">"La tecnología no reemplaza al aprendizaje; lo expande."</p>
                <p class="text-right text-[18px]  w-full text-black mb-8">-George Couros</p>
                <div class="lg:flex items-center justify-center">
                    <div class="lg:w-[50%] text-justify mb-10 lg:mb-0 lg:mr-12">
                        <h2 class="mt-4 mb-2 text-lg uppercase text-hgreen">Planes de estudio</h2>
                        <p>
                            Nuestros planes de estudio cuentan con el reconocimiento oficial de la Secretaría de Educación Pública (SEP). Los programas son diseñados por especialistas en cada área y supervisados por el consejo académico.
                        </p>
                        <br />
                        <h2 class="mt-4 mb-2 text-lg uppercase text-hgreen">Sistema por bloques</h2>
                        <p class="mb-4">
                            Universidad Humanitas es pionera en el Sistema por Bloques, un enfoque innovador que agrupa tres materias relacionadas dentro de una misma rama del programa de estudios, creando bloques especializados enfocados en áreas específicas.
                        </p>
                        <p>
                            Cada bloque es impartido por un profesor especialista, quien coordina los contenidos de las tres materias a lo largo de las  sesiones del trimestre, con una sesión adicional dedicada a la evaluación final.
                        </p>
                    </div>
                    <div class="flex items-center justify-center w-full lg:max-w-[520px] cursor-pointer">
						<VideoHiL :thumbnailUrl="img" :alt="'Mujer estudiante de modelo virtual de Universidad Humanitas'" :videoUrl="videoUrl" class="w-full lg:max-w-[520px] cursor-pointer"/>
					</div>
                </div>
            </div>  
        </div>
    </section>

	

	<section class="flex items-center justify-center my-16 w-full">
		<div class="lg:flex flex-col px-4 items-center w-full max-w-4xl lg:max-w-[1200px] justify-start">
			<div class="flex flex-col justify-between">
				
				<div class="lg:flex items-center justify-center">
                    <div class="flex items-center justify-center w-full lg:max-w-[520px]">
						<img src="/pagesImages/modelo-virtual-hombre.webp" alt="Estudiante modelo virtual Universidad Humanitas" class="w-full lg:max-w-[520px]"/>
					</div>
                    <div class="lg:w-[50%] text-justify lg:mt-0 mt-8 lg:mb-0 lg:ml-12">
                        <h2>
                            <span class="block text-[#73793B] leading-none text-left text-[28px]" style="">Metodología del</span>
                            <span class="sr-only whitespace-nowrap">&nbsp;</span>
                            <span class="block text-[#73793B] text-left font-serif mb-3 text-[42px]">Modelo Virtual</span>
                        </h2>
                        <ul class="list-disc pl-4 space-y-4">
                            <li>Los programas se desarrollan en bloques trimestrales.</li>
                            <li>
                                Cada bloque de especialización fusiona tres materias y es impartido por un especialista en la materia.
                            </li>
                            <li>
                                Cada semana se ofrece una clase grabada en formato de video y podcast disponible en la plataforma. Además, se abre un foro de discusión para resolver dudas y se proporcionan materiales visuales complementarios que fortalecen el autoestudio.
                            </li>
                            <li>
                                Se imparten sesiones en tiempo real, durante la primera, tercera, quinta, séptima y décima semana.
                            </li>
                            <li>
                                La evaluación final incluye la participación en clase, foros, trabajos y exámenes, lo que constituye el total de la calificación.
                            </li>
                        </ul>
                    </div>
                    
                </div>
			</div>
		</div>
	</section>

    

	<!-- <section class="flex flex-col items-center justify-center w-screen mb-16 bg-cover bg-[center] bg-no-repeat border border-gray-3" style="background-image: url(/pagesImages/columnas-bg.jpg);">
		<div class="w-full max-w-4xl lg:max-w-[1200px]">
			<div class="flex flex-col mt-8 items-center px-4">
				<p class="font-serif text-[42px] text-hgold leading-tight">Clases Muestra</p>
				<p class="text-[28px] mb-6 text-hgray leading-tight" >Tambi&eacute;n en Podcast</p>
				<p class="text-[18px]">Clases grabadas con formatos de alta definici&oacute;n,</p>
				<p class="text-[18px]">podcast y asesorias en tiempo real.</p>
			</div>
			<div class="my-10">
				<CarruVideosEscol />
			</div>
		</div>
	</section> -->

	<section class="flex justify-center items-center w-screen h-full  bg-cover mb-16 lg:bg-center bg-no-repeat mt-12" style="background-image: url(../pagesImages/perfil-alumno-virtual-humanitas.webp); ">
        <div class="lg:flex justify-between w-full max-w-4xl lg:max-w-[1200px] items-center">
            <div class="flex flex-col lg:justify-start justify-center items-center lg:items-start lg:w-[45%] w-full lg:my-20 my-12 text-justify px-4">
                <h2>
                    <span class="block text-[#73793B] leading-none text-left text-[28px]" style="">Perfil del alumno en el modelo</span>
                    <span class="sr-only whitespace-nowrap">&nbsp;</span>
                    <span class="block text-[#73793B] text-left font-serif mb-6 text-[42px]"> virtual Humanitas</span>
                </h2>
                <div class="text-base text-gray-800">
                    <p class="pb-4">
                        Los aspirantes al Modelo Virtual son personas que comprenden la flexibilidad de la modalidad. Cuentan con la autodisciplina necesaria para mantenerse motivados y enfocados en sus objetivos académicos.
                    </p>
                    <p class="pb-4">
                        Están comprometidos con la oportunidad de combinar sus responsabilidades, sin importar la ubicación geográfica y los horarios, en el que se encuentren. Priorizan su búsqueda de una educación superior de calidad y tienen la seguridad de cumplir con éxito los requisitos del programa.
                    </p>
                    <p>
                        Nuestros estudiantes se comprometen con la oportunidad de equilibrar sus responsabilidades personales y profesionales.
                    </p>
                </div>
            </div>
        </div>
    </section>

    <!-- <section class="flex justify-center w-full mt-8 mb-12">
		<div class="flex flex-col items-center w-full max-w-4xl lg:max-w-[1200px]">
			<h2 class="font-serif text-hgold text-[42px] leading-none mb-4">Oferta educativa en sistema virtual</h2>
			<HoverNivel :es-virtual="true"/>
		</div>
	</section> -->

    <!-- <EgresadosHuma :types="'Virtual'" class="mb-12" />

    <section class="flex items-center justify-center w-full">
        <div class="lg:flex justify-start w-full max-w-4xl lg:max-w-[1200px] items-center mb-12">
            <div class="flex items-center justify-center">
                <img src="/pagesImages/vive-eje.jpg" loading="lazy" alt="Humanitas Vive" />
            </div>
            <div class="flex flex-col lg:w-[50%] items-center text-justify lg:ml-12">
                <div class="mb-8 text-justify px-4">
                <div class="text-center lg:text-left w-full mt-6 lg:mt-0">
                    <h2>
                        <span class="block text-gray-700 mb-0 leading-tight font-normal text-[28px]">Programa</span>
                        <span class="sr-only whitespace-nowrap">&nbsp;</span>
                        <span class="block text-hgold mt-0 leading-tight font-serif text-[42px]">Humanitas Vive</span>
                    </h2>
                </div>
                <br />
                <p>
                    Es un programa de voluntariado enfocado en la responsabilidad social de Universidad Humanitas. A través de este, los alumnos pueden liberar su servicio social mediante diversas actividades, que pueden ser:
                </p>
                <br />
                <p class="pl-2">• Sociales</p>
                <p class="pl-2">• Culturales</p>
                <p class="pl-2">• De altruismo</p>
                <p class="pl-2">• Deportivas</p>
                <p class="pl-2">• Ambientales</p>
                <br />
                <p>
                    El programa se conforma de colaboraciones con instituciones autorizadas, a las cuales, Universidad Humanitas brinda apoyo mediante donativos en especie o económicos, así como a través de la organización de actividades alineadas con su labor.
                </p>
                </div>
            </div>
        </div>
    </section> -->

    <section class="flex items-center justify-center mb-16 w-full">
		<div class="lg:flex flex-col px-4 items-center w-full max-w-4xl lg:max-w-[1200px] justify-start">
			<div class="flex flex-col justify-between">
				<div class="lg:flex items-center justify-center">
                    <div class="flex items-center justify-center w-full lg:max-w-[520px]">
						<img src="/pagesImages/universidad-fisica-virtual.webp" alt="Universidad Humanitas tiene presencia fisica y virtual, la distancia ya no es un obstaculo." class="w-full lg:max-w-[520px]"/>
					</div>
                    <div class="lg:w-[50%] text-justify mt-8 lg:mt-0 lg:ml-12">
                        <h2>
                            <span class="block text-[#73793B] leading-none text-left text-[28px]" style="">Experiencia</span>
                            <span class="sr-only whitespace-nowrap">&nbsp;</span>
                            <span class="block text-[#73793B] text-left font-serif mb-3 text-[42px]">física y en línea</span>
                        </h2>
                        <p class="mb-4">
                            Al inscribirte como estudiante Humanitas en el Campus Virtual, formas parte de una comunidad académica en línea de alto nivel y obtienes acceso a nuestros campus físicos para utilizar sus instalaciones.
                        </p>
                        <p class="mb-4">
                            Entrarás de manera ilimitada a nuestra biblioteca virtual, donde encontrarás recursos actualizados y especializados para enriquecer tu formación. Además, puedes asistir a conferencias magistrales presenciales y estudiar en nuestros amplios jardines, espacios pensados para fomentar la reflexión, la creatividad y el aprendizaje profundo.
                        </p>
                        <p class="">
                            En Humanitas, combinamos lo mejor de la experiencia digital con el valor de los espacios presenciales.
                        </p>
                    </div>
                    
                </div>
			</div>
		</div>
	</section>

    <section class="flex flex-col items-center justify-center mb-16 w-full">
		<div class="lg:flex flex-col px-4 items-center w-full max-w-4xl lg:max-w-[1200px] justify-start">
			<div class="flex flex-col justify-between">
				<div class="lg:flex items-center justify-center">
                    <div class="lg:w-[50%] text-justify mb-10 lg:mb-0 lg:mr-12">
                        <h2>
                            <span class="block text-[#73793B] leading-none text-left text-[28px]" style="">Plan de actividades</span>
                            <span class="sr-only whitespace-nowrap">&nbsp;</span>
                            <span class="block text-[#73793B] text-left font-serif mb-3 text-[42px]">del modelo virtual</span>
                        </h2>
                        <p class="mb-4">
                            Cada una de las 11 semanas que componen un bloque trimestral, incluyen una clase grabada y un foro virtual de interacción para reforzar el aprendizaje.
                        </p>
                        <p class="mb-4">
                            Las clases 1, 3, 5 y 7 son sesiones en vivo, diseñadas para resolver dudas, profundizar en los temas y fomentar la participación activa. El examen final se lleva a cabo en la última sesión, consolidando los conocimientos adquiridos durante el trimestre.
                        </p>
                        <p>
                            Las clases en vivo quedan grabadas y disponibles en la plataforma. Además, los materiales de apoyo están disponibles en la plataforma las 24 horas, facilitando el aprendizaje autónomo. Cada módulo cuenta con actividades prácticas diseñadas para reforzar la comprensión y aplicación de los contenidos.
                        </p>
                    </div>
                    <div class="flex items-center justify-center lg:w-[50%]">
						<img src="/pagesImages/calendario-modelo-virtual-universidad-humanitas.png" alt="Cronograma del modelo virtual de Universidad Humanitas" class="w-full lg:max-w-[520px]"/>
                        <!-- <section class="relative flex lg:justify-center mb-6 w-full">
		<div class="absolute z-10 top-1/2 right-4 lg:hidden animate-pulse bg-hgold p-2 w-10 h-10 rounded-full flex items-center justify-center">
			<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-10 h-10 text-white">
				<path stroke-linecap="round" stroke-linejoin="round" d="m12.75 15 3-3m0 0-3-3m3 3h-7.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
			</svg>
		</div>
		<div class="overflow-auto flex lg:justify-center items-center w-full max-w-4xl lg:max-w-[1200px]">
			<div class="relative flex items-center lg:justify-center w-[856px] mb-4 px-4">
				<div class="overflow-x-scroll lg:overflow-hidden grid grid-cols-4 gap-x-2 w-[856px] text-white font-semibold text-lg py-2">
					<div class="relative w-[200px] h-[80px] border border-gray-300 bg-gray-100">
						<div class="absolute -top-2 left-2 flex justify-center items-center bg-hgold w-[180px] h-[80px]">Semana</div>
					</div>
					<div class="relative w-[200px] h-[80px] border border-gray-300 bg-gray-100">
						<div class="absolute -top-2 left-2 flex justify-center items-center bg-hwine w-[180px] h-[80px]">Clase<br>pre-grabada</div>
					</div>
					<div class="relative w-[200px] h-[80px] border border-gray-300 bg-gray-100">
						<div class="absolute -top-2 left-2 flex justify-center items-center bg-hwine w-[180px] h-[80px]">Clase en<br>tiempo real</div>
					</div>
					<div class="relative w-[200px] h-[80px] border border-gray-300 bg-gray-100">
						<div class="absolute -top-2 left-2 flex justify-center items-center bg-hwine w-[180px] h-[80px]">Foro</div>
					</div>
					<div class="flex items-center w-[200px] h-[35px] py-2 border-x-[1px] border-b-[1px] border-gray-300 bg-gray-100">
						<p class="w-full text-center text-gray-500">Semana 1</p>
					</div>
					<div class="flex items-center w-[200px] h-[35px] py-2 border-x-[1px] border-b-[1px] border-gray-300 bg-gray-100">
						<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="h-[35px] py-2 font-bold text-green-500 w-full">
							<path strokeLinecap="round" strokeLinejoin="round" d="m4.5 12.75 6 6 9-13.5" />
						</svg>
					</div>
					<div class="flex items-center w-[200px] h-[35px] py-2 border-x-[1px] border-b-[1px] border-gray-300 bg-gray-100">
						<p class="w-full text-center text-gray-500">&nbsp;</p>
					</div>
					<div class="flex items-center w-[200px] h-[35px] py-2 border-x-[1px] border-b-[1px] border-gray-300 bg-gray-100">
						<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="h-[35px] py-2 font-bold text-green-500 w-full">
							<path strokeLinecap="round" strokeLinejoin="round" d="m4.5 12.75 6 6 9-13.5" />
						</svg>
					</div>
					<div class="flex items-center w-[200px] h-[35px] py-2 border-x-[1px] border-b-[1px] border-gray-300 bg-gray-100">
						<p class="w-full text-center text-gray-500">Semana 2</p>
					</div>
					<div class="flex items-center w-[200px] h-[35px] py-2 border-x-[1px] border-b-[1px] border-gray-300 bg-gray-100">
						<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="h-[35px] py-2 font-bold text-green-500 w-full">
							<path strokeLinecap="round" strokeLinejoin="round" d="m4.5 12.75 6 6 9-13.5" />
						</svg>
					</div>
					<div class="flex items-center w-[200px] h-[35px] py-2 border-x-[1px] border-b-[1px] border-gray-300 bg-gray-100">
						<p class="w-full text-center text-gray-500">&nbsp;</p>
					</div>
					<div class="flex items-center w-[200px] h-[35px] py-2 border-x-[1px] border-b-[1px] border-gray-300 bg-gray-100">
						<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="h-[35px] py-2 font-bold text-green-500 w-full">
							<path strokeLinecap="round" strokeLinejoin="round" d="m4.5 12.75 6 6 9-13.5" />
						</svg>
					</div>
					<div class="flex items-center w-[200px] h-[35px] py-2 border-x-[1px] border-b-[1px] border-gray-300 bg-gray-100">
						<p class="w-full text-center text-gray-500">Semana 3</p>
					</div>
					<div class="flex items-center w-[200px] h-[35px] py-2 border-x-[1px] border-b-[1px] border-gray-300 bg-gray-100">
						<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="h-[35px] py-2 font-bold text-green-500 w-full">
							<path strokeLinecap="round" strokeLinejoin="round" d="m4.5 12.75 6 6 9-13.5" />
						</svg>
					</div>
					<div class="flex items-center w-[200px] h-[35px] py-2 border-x-[1px] border-b-[1px] border-gray-300 bg-gray-100">
						<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="h-[35px] py-2 font-bold text-green-500 w-fit">
							<path strokeLinecap="round" strokeLinejoin="round" d="m4.5 12.75 6 6 9-13.5" />
						</svg><span class="text-sm text-gray-500">Repaso y aclaraci&oacute;n de dudas</span>
					</div>
					<div class="flex items-center w-[200px] h-[35px] py-2 border-x-[1px] border-b-[1px] border-gray-300 bg-gray-100">
						<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="h-[35px] py-2 font-bold text-green-500 w-full">
							<path strokeLinecap="round" strokeLinejoin="round" d="m4.5 12.75 6 6 9-13.5" />
						</svg>
					</div>
					<div class="flex items-center w-[200px] h-[35px] py-2 border-x-[1px] border-b-[1px] border-gray-300 bg-gray-100">
						<p class="w-full text-center text-gray-500">Semana 4</p>
					</div>
					<div class="flex items-center w-[200px] h-[35px] py-2 border-x-[1px] border-b-[1px] border-gray-300 bg-gray-100">
						<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="h-[35px] py-2 font-bold text-green-500 w-full">
							<path strokeLinecap="round" strokeLinejoin="round" d="m4.5 12.75 6 6 9-13.5" />
						</svg>
					</div>
					<div class="flex items-center w-[200px] h-[35px] py-2 border-x-[1px] border-b-[1px] border-gray-300 bg-gray-100">
						<p class="w-full text-center text-gray-500">&nbsp;</p>
					</div>
					<div class="flex items-center w-[200px] h-[35px] py-2 border-x-[1px] border-b-[1px] border-gray-300 bg-gray-100">
						<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="h-[35px] py-2 font-bold text-green-500 w-full">
							<path strokeLinecap="round" strokeLinejoin="round" d="m4.5 12.75 6 6 9-13.5" />
						</svg>
					</div>
					<div class="flex items-center w-[200px] h-[35px] py-2 border-x-[1px] border-b-[1px] border-gray-300 bg-gray-100">
						<p class="w-full text-center text-gray-500">Semana 5</p>
					</div>
					<div class="flex items-center w-[200px] h-[35px] py-2 border-x-[1px] border-b-[1px] border-gray-300 bg-gray-100">
						<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="h-[35px] py-2 font-bold text-green-500 w-full">
							<path strokeLinecap="round" strokeLinejoin="round" d="m4.5 12.75 6 6 9-13.5" />
						</svg>
					</div>
					<div class="flex items-center w-[200px] h-[35px] py-2 border-x-[1px] border-b-[1px] border-gray-300 bg-gray-100">
						<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="h-[35px] py-2 font-bold text-green-500 w-fit">
							<path strokeLinecap="round" strokeLinejoin="round" d="m4.5 12.75 6 6 9-13.5" />
						</svg><span class="text-sm text-gray-500">Repaso y aclaraci&oacute;n de dudas</span>
					</div>
					<div class="flex items-center w-[200px] h-[35px] py-2 border-x-[1px] border-b-[1px] border-gray-300 bg-gray-100">
						<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="h-[35px] py-2 font-bold text-green-500 w-full">
							<path strokeLinecap="round" strokeLinejoin="round" d="m4.5 12.75 6 6 9-13.5" />
						</svg>
					</div>
					<div class="flex items-center w-[200px] h-[35px] py-2 border-x-[1px] border-b-[1px] border-gray-300 bg-gray-100">
						<p class="w-full text-center text-gray-500">Semana 6</p>
					</div>
					<div class="flex items-center w-[200px] h-[35px] py-2 border-x-[1px] border-b-[1px] border-gray-300 bg-gray-100">
						<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="h-[35px] py-2 font-bold text-green-500 w-full">
							<path strokeLinecap="round" strokeLinejoin="round" d="m4.5 12.75 6 6 9-13.5" />
						</svg>
					</div>
					<div class="flex items-center w-[200px] h-[35px] py-2 border-x-[1px] border-b-[1px] border-gray-300 bg-gray-100">
						<p class="w-full text-center text-gray-500">&nbsp;</p>
					</div>
					<div class="flex items-center w-[200px] h-[35px] py-2 border-x-[1px] border-b-[1px] border-gray-300 bg-gray-100">
						<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="h-[35px] py-2 font-bold text-green-500 w-full">
							<path strokeLinecap="round" strokeLinejoin="round" d="m4.5 12.75 6 6 9-13.5" />
						</svg>
					</div>
					<div class="flex items-center w-[200px] h-[35px] py-2 border-x-[1px] border-b-[1px] border-gray-300 bg-gray-100">
						<p class="w-full text-center text-gray-500">Semana 7</p>
					</div>
					<div class="flex items-center w-[200px] h-[35px] py-2 border-x-[1px] border-b-[1px] border-gray-300 bg-gray-100">
						<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="h-[35px] py-2 font-bold text-green-500 w-full">
							<path strokeLinecap="round" strokeLinejoin="round" d="m4.5 12.75 6 6 9-13.5" />
						</svg>
					</div>
					<div class="flex items-center w-[200px] h-[35px] py-2 border-x-[1px] border-b-[1px] border-gray-300 bg-gray-100">
						<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="h-[35px] py-2 font-bold text-green-500 w-fit">
							<path strokeLinecap="round" strokeLinejoin="round" d="m4.5 12.75 6 6 9-13.5" />
						</svg><span class="text-sm text-gray-500">Repaso y aclaraci&oacute;n de dudas</span>
					</div>
					<div class="flex items-center w-[200px] h-[35px] py-2 border-x-[1px] border-b-[1px] border-gray-300 bg-gray-100">
						<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="h-[35px] py-2 font-bold text-green-500 w-full">
							<path strokeLinecap="round" strokeLinejoin="round" d="m4.5 12.75 6 6 9-13.5" />
						</svg>
					</div>
					<div class="flex items-center w-[200px] h-[35px] py-2 border-x-[1px] border-b-[1px] border-gray-300 bg-gray-100">
						<p class="w-full text-center text-gray-500">Semana 8</p>
					</div>
					<div class="flex items-center w-[200px] h-[35px] py-2 border-x-[1px] border-b-[1px] border-gray-300 bg-gray-100">
						<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="h-[35px] py-2 font-bold text-green-500 w-full">
							<path strokeLinecap="round" strokeLinejoin="round" d="m4.5 12.75 6 6 9-13.5" />
						</svg>
					</div>
					<div class="flex items-center w-[200px] h-[35px] py-2 border-x-[1px] border-b-[1px] border-gray-300 bg-gray-100">
						<p class="w-full text-center text-gray-500">&nbsp;</p>
					</div>
					<div class="flex items-center w-[200px] h-[35px] py-2 border-x-[1px] border-b-[1px] border-gray-300 bg-gray-100">
						<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="h-[35px] py-2 font-bold text-green-500 w-full">
							<path strokeLinecap="round" strokeLinejoin="round" d="m4.5 12.75 6 6 9-13.5" />
						</svg>
					</div>
					<div class="flex items-center w-[200px] h-[35px] py-2 border-x-[1px] border-b-[1px] border-gray-300 bg-gray-100">
						<p class="w-full text-center text-gray-500">Semana 9</p>
					</div>
					<div class="flex items-center w-[200px] h-[35px] py-2 border-x-[1px] border-b-[1px] border-gray-300 bg-gray-100">
						<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="h-[35px] py-2 font-bold text-green-500 w-full">
							<path strokeLinecap="round" strokeLinejoin="round" d="m4.5 12.75 6 6 9-13.5" />
						</svg>
					</div>
					<div class="flex items-center w-[200px] h-[35px] py-2 border-x-[1px] border-b-[1px] border-gray-300 bg-gray-100">
						<p class="w-full text-center text-gray-500">&nbsp;</p>
					</div>
					<div class="flex items-center w-[200px] h-[35px] py-2 border-x-[1px] border-b-[1px] border-gray-300 bg-gray-100">
						<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="h-[35px] py-2 font-bold text-green-500 w-full">
							<path strokeLinecap="round" strokeLinejoin="round" d="m4.5 12.75 6 6 9-13.5" />
						</svg>
					</div>
					<div class="flex items-center w-[200px] h-[35px] py-2 border-x-[1px] border-b-[1px] border-gray-300 bg-gray-100">
						<p class="w-full text-center text-gray-500">Semana 10</p>
					</div>
					<div class="flex items-center w-[200px] h-[35px] py-2 border-x-[1px] border-b-[1px] border-gray-300 bg-gray-100">
						<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="h-[35px] py-2 font-bold text-green-500 w-full">
							<path strokeLinecap="round" strokeLinejoin="round" d="m4.5 12.75 6 6 9-13.5" />
						</svg>
					</div>
					<div class="flex items-center w-[200px] h-[35px] py-2 border-x-[1px] border-b-[1px] border-gray-300 bg-gray-100">
						<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="h-[35px] py-2 font-bold text-green-500 w-fit">
							<path strokeLinecap="round" strokeLinejoin="round" d="m4.5 12.75 6 6 9-13.5" />
						</svg><span class="text-sm text-gray-500">Repaso y aclaraci&oacute;n de dudas</span>
					</div>
					<div class="flex items-center w-[200px] h-[35px] py-2 border-x-[1px] border-b-[1px] border-gray-300 bg-gray-100">
						<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="h-[35px] py-2 font-bold text-green-500 w-full">
							<path strokeLinecap="round" strokeLinejoin="round" d="m4.5 12.75 6 6 9-13.5" />
						</svg>
					</div>
					<div class="flex items-center w-[200px] h-[35px] py-2 border-x-[1px] border-b-[1px] border-gray-300 bg-gray-100">
						<p class="w-full text-center text-gray-500">Semana 11</p>
					</div>
					<div class="flex items-center w-[200px] h-[35px] py-2 border-x-[1px] border-b-[1px] border-gray-300 bg-gray-100">
						<p class="w-full text-center text-gray-500">&nbsp;</p>
					</div>
					<div class="relative w-[200px] h-[35px] py-2 border-x-[1px] border-b-[1px] border-gray-300 bg-gray-100">
						<div class="absolute -bottom-2 left-2 flex justify-center items-center bg-hwine w-[180px] h-[35px] py-2 uppercase text-sm">Evaluaci&oacute;n final</div>
					</div>
					<div class="flex items-center w-[200px] h-[35px] py-2 border-x-[1px] border-b-[1px] border-gray-300 bg-gray-100">
						<p class="w-full text-center text-gray-500">&nbsp;</p>
					</div>
				</div>
			</div>
		</div>
	</section> -->
					</div>
                </div>
			</div>
		</div>
	</section>

    <div class="flex items-center justify-center w-full mb-16 bg-cover bg-[center] bg-no-repeat" style="
        background-image: url(/pagesImages/reyes1.jpg);
        position: relative;
        background-attachment: fixed;
        background-position: right;
        background-repeat: no-repeat;
        background-size: cover;
        overflow: hidden;
        transition: transform 0.3s ease;
    ">
        <div class="flex justify-center  w-full" style="background-color: rgb(255 255 255 / 0.7);">
            <div class="flex flex-col items-center justify-center w-full max-w-4xl my-16 lg:max-w-[1200px]">
                <div class="lg:flex items-center justify-between w-full">
                    <div class="flex flex-col lg:w-[45%] lg:mx-0 mx-8 lg:mb-0 mb-8 text-gray-800">
                        <h2 class="text-[#73793B] text-left font-serif md:text-[42px] text-[32px] mb-10 leading-none w-full">
                            <span class="block">¿Qué incluye cada curso?</span>
                        </h2>
                        <div class="flex text-justify items-center lg:hyphens-none hyphens-auto mb-3"><i class="fas fa-desktop text-[#73793B] mr-4" ></i> Plataforma especializada para el seguimiento de avance en tus estudios.</div>
                        <div class="flex text-justify items-center lg:hyphens-none hyphens-auto mb-3"><i class="fas fa-video text-[#73793B] mr-4" ></i> Clases pregrabadas en Alta Definición.</div>
                        <div class="flex text-justify items-center lg:hyphens-none hyphens-auto mb-3"><i class="fas fa-clock text-[#73793B] mr-4" ></i> Duración entre 30 y 45 minutos.</div>
                        <div class="flex text-justify items-center lg:hyphens-none hyphens-auto mb-3"><i class="fas fa-user text-[#73793B] mr-4" ></i> Profesores con amplia experiencia profesional y activos en su campo laboral.</div>
                        <div class="flex text-justify items-center lg:hyphens-none hyphens-auto mb-3"><i class="fas fa-file-alt text-[#73793B] mr-4" ></i> Materiales visuales profesionales como material de apoyo.</div>
                        <div class="flex text-justify items-center lg:hyphens-none hyphens-auto mb-3"><i class="fas fa-headset text-[#73793B] mr-4" ></i> Podcast para escuchar la clase.</div>
                        <div class="flex text-justify items-center lg:hyphens-none hyphens-auto mb-3"><i class="fas fa-question-circle text-[#73793B] mr-4" ></i> Foros de seguimiento con el docente.</div>
                        <div class="flex text-justify items-center lg:hyphens-none hyphens-auto mb-3"><i class="fas fa-book-open text-[#73793B] mr-4" ></i> Acceso a la biblioteca digital.</div>
                        <div class="flex text-justify items-center lg:hyphens-none hyphens-auto mb-3"><i class="fas fa-smile text-[#73793B] mr-4" ></i> Enfoque dinámico.</div>
                    </div>
                    <div class="flex items-center justify-center w-full lg:max-w-[520px] lg:px-0 px-8">
                        <img src="/pagesImages/landing-virtual-banner-mundo.webp" alt="Universidad Humanitas tiene presencia fisica y virtual, la distancia ya no es un obstaculo." class="w-full lg:max-w-[500px]"/>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <OfertaBotones />

    <div class="flex items-center justify-center w-full mb-16">
        <div class="flex flex-col items-center justify-center w-full max-w-4xl lg:max-w-[1200px]">
            <h2 class="text-[#73793B] text-center font-serif md:text-[42px] text-[32px] mb-16 leading-none w-full">
                <span class="block">Graduados Humanitas</span>
            </h2>
            <div class="flex items-center justify-center w-full">
                <GraficoMapa />
            </div>
        </div>
    </div>

    <section class="flex items-center justify-center mb-16 w-full">
		<div class="lg:flex flex-col px-4 items-center w-full max-w-4xl lg:max-w-[1200px] justify-start">
			<div class="flex flex-col justify-between">
				<div class="lg:flex items-center justify-center">
                    <div class="lg:w-[50%] text-justify mt-8 lg:mt-0 lg:mr-12">
                        <h2>
                            <span class="block text-[#73793B] text-left font-serif mb-3 text-[42px]">Convalidaciones</span>
                        </h2>
                        <p class="mb-4">
                            El trámite de convalidación de estudios debe realizarse directamente en el país de origen, a través de las autoridades educativas correspondientes.<br>Recomendamos contactar con el organismo oficial encargado de la homologación o convalidación a fin de conocer los requisitos y procedimientos específicos.
                        </p>
                    </div>
                    <div class="flex items-center justify-center w-full lg:max-w-[520px]">
						<img src="/pagesImages/convalidaciones-mapa-celular.webp" alt="Universidad Humanitas tiene presencia fisica y virtual, la distancia ya no es un obstaculo." class="w-full lg:max-w-[520px]"/>
					</div>
                </div>
			</div>
		</div>
	</section>

    <div class="flex items-center justify-center w-full mb-16 relative">
        <div class="flex flex-col items-center justify-center w-full max-w-4xl lg:max-w-[1200px] relative flex-wrap">
            <h2 class="text-[#73793B] text-center font-serif md:text-[42px] text-[32px] mb-16 leading-none w-full">
                <span class="block">Vive la experiencia educativa</span>
                <span class="sr-only whitespace-nowrap">&nbsp;</span>
                <span class="block">con nuestra clase muestra</span>
            </h2>
            <div class="lg:flex items-center justify-between w-full mb-16 flex-wrap ">
                <div class="flex flex-col lg:w-[45%] lg:mb-0 mb-8 lg:px-0 px-4">
                    <h3 class="text-lg text-justify font-semibold">Clases Pre-grabadas</h3>
                    <p class="text-justify lg:hyphens-none hyphens-auto">Disponibles en video para visualizarlas desde cualquier dispositivo en cualquier momento. Diseñadas con producción de alto nivel y recursos digitales innovadores. Nuestras clases permiten a los alumnos experimentar de primera mano la calidad académica y la innovación que nos distinguen.</p>
                </div>
                <iframe width="560" height="315" src="https://www.youtube.com/embed/iC85r-l4tYk?si=RQMvYidYOLicSECx" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen class="md:max-w-[560px] w-full lg:px-0 px-4"></iframe>
            </div>
            <div class="lg:flex items-center justify-between content-center place-items-center w-full mb-16 flex-wrap">
                <div class="relative md:w-[539px] md:h-[539px] w-[361.6px] h-[361.6px] content-center lg:px-0 px-4 bg-[url('/pagesImages/landing-virtual-podcast.webp')] bg-cover bg-center rounded-none shadow-lg flex items-end justify-center p-6" width="560" height="315">
                    <!-- Contenedor del reproductor -->
                    <div class="relative z-10 flex flex-col items-center  bottom-0 justify-center">
                        <audio controls class="lg:w-[360px]">
                            <source src="/assets/mp3/LDB01C01.mp3" type="audio/mp3">
                            Tu navegador no soporta el elemento de audio.
                        </audio>
                    </div>
                </div>
                <div class="flex flex-col lg:w-[45%] lg:mt-0 mt-8 lg:px-0 px-4">
                    <h3 class="text-lg text-justify font-semibold">Podcast</h3>
                    <p class="text-justify lg:hyphens-none hyphens-auto ">Conocimiento especializado en cualquier momento con charlas de expertos y especialistas. Convierte tus tiempos de traslado en oportunidades de aprendizaje, escucha tus clases en podcast mientras realizas actividades diarias y maximiza tu potencial académico.</p>
                </div>
            </div>
            <div class="lg:flex items-center justify-between w-full flex-wrap relative ">
                <div class="flex flex-col lg:w-[45%] lg:mb-0 mb-8 lg:px-0 px-4">
                    <h3 class="text-lg text-justify font-semibold">Presentación</h3>
                    <p class="text-justify lg:hyphens-none hyphens-auto">Contenidos visuales diseñados para maximizar la comprensión y el aprendizaje. Son materiales de estudio profesionales que son de gran utilidad para las sesiones y las dinámicas grupales.</p>
                </div>
                <div class="w-full lg:w-[560px] flex-shrink-0 lg:mt-0 mt-8 relative lg:px-0 px-4">
                    <Presentacion />
                </div>
            </div>
        </div>
    </div>

    <section
    class="lg:flex items-center w-full justify-center bg-cover bg-[center] bg-no-repeat mb-16"
    style="
      background-image: url(/pagesImages/modelo-ejec-respon.jpg);
      position: relative;
      background-attachment: fixed;
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
      overflow: hidden;
      transition: transform 0.3s ease;
    ">
        <div class="flex justify-center  w-full" style="background-color: rgb(255 255 255 / 0.7);">
            <div class="lg:flex justify-center items-center lg:my-12 w-full max-w-[1200px]">
                <div class="flex items-center justify-center ">
                    <img
                        src="/pagesImages/modelo-virtual-graduado.webp" alt="Excelencia académica en Universidad Humanitas"
                        class="lg:mr-12 max-w-[520px] "
                    />
                </div>
                <div class=" py-16 px-4 lg:px-0">
                    <div class="text-center lg:text-left">
                        <h2>
                            <span class="block text-[#73793B] leading-none text-[28px] font-montse">Excelencia</span>
                            <span class="sr-only whitespace-nowrap">&nbsp;</span>
                            <span class="block text-[#73793B] leading-none mb-4 font-serif text-[42px]">Acad&eacute;mica</span>
                        </h2>
                    </div>
                    <p class="text-justify text-gray-800">
                        En Universidad Humanitas, la excelencia académica es nuestro compromiso fundamental. Ofrecemos programas de alta calidad diseñados por expertos, que fomentan el pensamiento crítico, la creatividad y la innovación, preparando a nuestros estudiantes para enfrentar los desafíos del mundo profesional.<br /><br />
                        Nuestro cuerpo docente altamente calificado acompaña a los estudiantes en su desarrollo académico y personal, creando un entorno propicio para el crecimiento. Fomentamos el aprendizaje colaborativo y la creación de redes profesionales, abriendo oportunidades para el futuro.<br><br>Formamos no solo profesionales de excelencia, sino también seres humanos comprometidos con su entorno, convencidos de que la educación es la clave para transformar el futuro.
                    </p>
                </div>
            </div>
        </div>
    </section>

    <section class="flex  justify-center mb-16 w-full">
		<div class="lg:flex flex-col lg:px-0 px-4 items-center w-full max-w-4xl lg:max-w-[1200px] justify-start">
			<div class="flex flex-col justify-between">
				<div class="lg:flex justify-center">
                    <div class="flex items-center justify-center w-full lg:max-w-[520px]">
						<img src="/pagesImages/herramientas-inteligencia-artificial-humanitas.webp" alt="Herramientas de inteligencia artificial aplicadas en Universidad Humanitas" class="w-full lg:max-w-[520px]"/>
					</div>
                    <div class="lg:w-[50%] text-justify mt-8 lg:mt-0 lg:ml-12">
                        <h2>
                            <span class="block leading-none text-left text-[28px]" style="">Política y uso de herramientas IA en</span>
                            <span class="sr-only whitespace-nowrap">&nbsp;</span>
                            <span class="block text-hgreen text-left font-serif mb-3 text-[42px]">Universidad Humanitas</span>
                        </h2>
                        <div class="text-justify">
                            <p class="mb-4 lg:hyphens-manual hyphens-auto">En Humanitas entendemos que el mundo está cambiando a gran velocidad. La Inteligencia Artificial ya forma parte del día a día de los estudiantes, y en lugar de rechazarla, enseñamos a aprovecharla con inteligencia, ética y sentido crítico.</p>
                            <p class="mb-4 lg:hyphens-manual hyphens-auto">Los alumnos no solo aprenderán a usar herramientas como ChatGPT, editores inteligentes o plataformas personalizadas. Desarrollarán capacidad de pensamiento crítico y analítico con el objetivo de debatir y defender las ideas, combinando tecnología avanzada con el desarrollo humano.
                            </p>
                            <p class="mb-4 lg:hyphens-manual hyphens-auto">Nuestro modelo académico integra la IA como una aliada del aprendizaje, pero nunca como un sustituto del pensamiento. Formamos para enfrentar el futuro con criterio, creatividad y preparación real.
                            </p>
                            <p class=" font-semibold text-center">Estudia en Humanitas, donde la tecnología potencia tu mente, no la reemplaza.</p>
                        </div>
                    </div>
                </div>
			</div>
		</div>
	</section>

	<!-- <section class="flex items-center w-full justify-center">
        <div class="lg:flex items-center max-w-4xl lg:max-w-[1200px]">
            <div class="flex items-center w-full justify-center">
                <img src="./pagesImages/shield-tr.png">
            </div>
            <div class="flex justify-center w-full items-center px-4 mb-10">
                <div class="flex flex-col justify-center items-center lg:items-start w-full">
                    <p class="text-[28px] leading-none">Plataforma</p>
                    <p class="text-hgold leading-none mb-2 font-serif text-[42px]">Humanitas</p>
                    <p class="text-justify">Consultas de acceso a horarios, finanzas, historial acad&eacute;mico, avisos, calendarios, expediente personal, eventos y redes sociales.<br><br>
                    Apoyo en plataformas de alto desempe&ntilde;o, como Google Empresarial, con la cual alumnos y docentes tienen acceso a un correo personalizado, as&iacute; como a distintas herramientas pr&aacute;cticas de comunicaci&oacute;n.<br><br>
                    Ingreso a la Biblioteca Virtual para consultar o adquirir libros electr&oacute;nicos, que se pueden descargar en cualquier dispositivo.</p>
                    <br>
                    <router-link to="/acceso-a-usuarios">
                        <div class="flex items-center justify-center w-[140px] h-[35px] py-2 bg-hwine hover:bg-hgold text-white text-lg font-semibold transition duration-300 ease-in-out">
                            <span>Acceder</span>
                        </div>
                    </router-link>
                </div>
            </div>
        </div>
    </section> -->
	<!-- <section class="flex items-center justify-center w-full mb-24">
		<div class="flex items-center justify-end bg-cover bg-[right_center] bg-no-repeat w-full max-w-4xl lg:max-w-[1200px] h-[300px] md:h-[500px] px-4 md:px-10" style="background-image: url(/pagesImages/Superate.jpg);">
			<div class="w-[210px] md:w-full md:max-w-[340px]">
				<p class="text-left lg:text-[28px] text-[20px] font-montse text-white  leading-none">Sup&eacute;rate desde cualquier parte del mundo</p>
				<p class="text-left lg:text-[36px] text-[30px]  text-hgold  font-serif">Modelo Virtual</p>
				<p class="text-left lg:text-[22px] text-white md:mb-4">Mensualidades desde&nbsp;<span class="hidden md:flex font-bold">${{ colegiaturaLicEjec.toLocaleString('es-MX') }}.00</span></p>
				<p class="md:hidden text-left lg:text-[22px] text-white mb-4 font-bold">${{ colegiaturaLicEjec.toLocaleString('es-MX') }}.00</p>
				<router-link to="/contacto" class="">
					<div class="flex items-center justify-center w-[140px] h-[35px] py-2 bg-white/70 hover:bg-hgold text-[#73793B] border-2 border-hwine text-lg transition duration-300 ease-in-out">
						<span>Inscr&iacute;bete</span>
					</div>
				</router-link>
			</div>
		</div>
	</section> -->
</template>

<style scoped>
.box {
    transform: translateX(110%); /* Fuera del viewport */
    transition: transform 1.35s ease-in-out;
}

.box.visible {
    transform: translateX(0); /* Posición original */
}
</style>